import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { DropdownItem } from '@app/components';
import { useAppContext } from '@app/contexts';
import { useFeatureFlag } from '@app/hooks';
import { makeRequest } from '@app/utils';
import { Feature } from '@app/constants';

interface ServicePointsDto {
  allowedServicePoints: { id: string; name: string }[];
}

interface UseAllowedServicePointsFetchProps {
  id: string;
  shouldFetch: boolean;
}

export const useAllowedServicePointsFetch = ({
  id,
  shouldFetch,
}: UseAllowedServicePointsFetchProps): UseQueryResult<DropdownItem[]> => {
  const { isLoggedIn, patronSession } = useAppContext();
  const { isActive: isConsortiaLogin } = useFeatureFlag({
    name: Feature.consortiaLoginFlow,
  });

  return useQuery<ServicePointsDto, unknown, DropdownItem[]>(
    ['allowedLocations', id],
    () =>
      makeRequest({
        url: `/opac-patron/account/${patronSession?.user?.externalSystemId}/instance/${id}/allowed-service-points`,
        withCredentials: isConsortiaLogin,
      }),
    {
      enabled: isLoggedIn && shouldFetch,
      select: data =>
        data.allowedServicePoints
          .map(({ id, name }) => ({ label: name, id }))
          .sort((a, b) => a.label.localeCompare(b.label)),
    }
  );
};
